import { history } from '@/components/root';
import { ROUTE_WORKFLOW_DASHBOARD } from '@/constant/routes';
import { ErrorPage } from '@/components/errorPage/errorPage';

export const PageUnauthorized = () => {
  const goToHome = () => history.push(ROUTE_WORKFLOW_DASHBOARD);

  return (
    <ErrorPage
      onHomeClick={goToHome}
      description="You don't have access to this page"
    />
  );
};
